import React from 'react';
import listStyles from './TextFooter.module.css';
import useAccessibility from 'hooks/useAccessibility';
import styles from "../common/CardSpectacle.module.css";
import { Link } from "react-router-dom";
import Button from 'components/common/Button';
import ButtonLink from 'components/common/ButtonLink';

const TextFooter = () => {
  const accessibilityVariant = useAccessibility();

  const textHeading = "Ne manquez plus aucun événement";
  const textclassic = "";
  const btnLabel = "Voir le programme";

  return (
    <div
      className={`${listStyles.container} ${listStyles[accessibilityVariant]}`}
      aria-labelledby="contact-info-title"
    >
      <div className={listStyles.content}>
        <div className={listStyles.block}>

          <h3>{textHeading}</h3>

          <p>{textclassic}</p>

          <ButtonLink link={"/programme"} ariaLabel={btnLabel} label={btnLabel} variant={"white"} />

        </div>
      </div>
    </div>
  );
};

export default TextFooter;
